<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container-fluid">
      <div class="col-md-2"></div>
      <div class="col-md-8">
        <div class="card bg-light mb-7 center-block">
          <center><h2 class="card-header">Delete Account Request</h2></center>
          <div class="card-body">
            <div class="card-text">
              <p class="lead">
                <table class="table" style="word-wrap:break-word; table-layout: fixed;">
                  <tbody>
                    <tr >
                      <th>Requesting User</th>
                      <th v-if="permissions.currentPermissions.SYS_GRANT_ACCESS">
                        <a :href="getUserInfoUrl()">{{ userDisplayName }}</a>
                      </th>
                      <th v-else>
                        {{ userDisplayName }}
                      </th>
                    </tr>
                    <tr >
                      <th>User Email</th><th>{{ userEmail }}</th>
                    </tr>
                    <tr>
                      <th>Reason</th><th>{{ revokeConsentRequest.reason }}</th>
                    </tr>
                    <tr >
                      <th>Number of resources (non-templates)</th><th>{{ numResources }}</th>
                    </tr>
                    <tr >
                      <th>Number of IRRs (Owned)</th><th>{{ (numIrrOwner) }}</th>
                    </tr>
                    <tr>
                      <th>Request Date</th><th>{{ formatDate(revokeConsentRequest.created_at) }}</th>
                    </tr>
                    <tr v-if="revokeConsentRequest.completed">
                      <th>Status</th><th>Completed on {{ formatDate(revokeConsentRequest.completed_ts) }}</th>
                    </tr>
                    <tr v-if="!revokeConsentRequest.completed">
                      <th>Status</th>
                      <th v-if="revokeConsentRequest.verified">Pending</th>
                      <th v-else>Not Verified</th>
                    </tr>
                    <tr>
                      <th>&nbsp;</th><th>&nbsp;</th>
                    </tr>
                  </tbody>
                </table>
                <div v-if="permissions.currentPermissions.SYS_GRANT_ACCESS && (Number(numResources) || Number(numIrrOwner))">
                  <p>
                    * This user currently owns 1 or more resources and/or registries (as an IRR owner).  The account cannot be deleted until those are deleted or transferred to another user.
                  </p>
                </div>
                <div v-else-if="permissions.currentPermissions.SYS_GRANT_ACCESS">
                  <p>
                    <div v-if="permissions.currentPermissions.SYS_GRANT_ACCESS && !revokeConsentRequest.completed && revokeConsentRequest.verified && !Number(numResources) && !Number(numIrrOwner)" class="form-check">
                      <input class="form-check-input" type="checkbox" onclick="if($('#deleteCheck').is(':checked')) { $('#deleteButton').show(); } else { $('#deleteButton').hide(); }" value="" id="deleteCheck">
                      <label class="form-check-label" for="deleteCheck">
                        <span class="font-weight-bold" style="color:red" onclick="if($('#deleteCheck').is(':checked')) { $('#deleteButton').show(); } else { $('#deleteButton').hide(); }">I want to complete this request and delete the account.</span>
                      </label>
                    </div>
                  </p>
                </div>
                <a v-if="permissions.currentPermissions.SYS_GRANT_ACCESS" type="button" :href="getUserInfoUrl()" class="btn btn-sm btn-primary mt-3">View User Details</a>
                <form v-if="permissions.currentPermissions.SYS_GRANT_ACCESS && !revokeConsentRequest.completed && revokeConsentRequest.verified && !Number(numResources) && !Number(numIrrOwner)" method="POST" :action="getCompletePendingRequestUrl()" style="display:inline;">
                  <input type="hidden" name="_token" :value="csrf_token">
                  <button type="submit" id="deleteButton" class="btn btn-sm btn-danger mt-3" style="display:none;">Delete This Account</button>
                </form>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>

<script>
    export default {
    props: {
      route: String,
      csrf_token: String,
      permissions: Object,
      revokeConsentRequest: [Object, Array],
      userDisplayName: String,
      userEmail: String,
      numResources: String,
      numIrrOwner: String,
      userId: String,
    },
    methods: {
      formatDate: function(ts) {
        var date = new Date(ts);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();

        day = '0' + day;
        month = '0' + month;
        day = (day.length == 2) ? day : day.slice(1);
        month = (month.length == 2) ? month : month.slice(1);

        return year + '-' + month + '-' + day;
      },
      getUserInfoUrl: function() {
        return '/admin/showuser/' + this.userId;
      },
      getCompletePendingRequestUrl: function() {
        return '/revoke-consent-request/complete/' + this.revokeConsentRequest.id;
      },
    },
    mounted(){
        //
      },
    }
</script>
